import axios from "axios";
import { getItemFromStorage } from "../utils/helper";
import { APIROUTE, STORAGE_KEYS } from "./config";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL || APIROUTE.baseUrl,
  timeout: 300000,
});

axiosInstance.interceptors.request.use(async(config) => {
  const token = await getItemFromStorage(STORAGE_KEYS.TOKEN);
  if (token) {
    config.headers["x-access-token"] = token || "";
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;